import { useListGlobalTopicsPageModel } from './list-global-topics-page.model'
import { ListGlobalTopicsPageView } from './list-global-topics-page.view'

export const ListGlobalTopicsPage = () => {
  const listGlobalTopicsPageModel = useListGlobalTopicsPageModel()
  return <ListGlobalTopicsPageView {...listGlobalTopicsPageModel} />
}
